<div *ngIf="isSubsidiaryAccount" class="subsidiary__account-alert">
  <a class="subsidiary__account-alert-link" [href]="shoppingListLink">
    <mm-icon *ngIf="!isMobileOrTablet" class="subsidiary__account-alert-icon" name="info"></mm-icon>
    <p class="subsidiary__account-alert-info">
      <span class="subsidiary__account-alert-title" *ngIf="!hideSubsidiaryAccountAlertTitle">
        {{ 'SUBSIDIARY_ASSORTMENT.NOTIFICATION.TITLE' | translate: {keyAccountName: organizationName} }}
      </span>
      <span class="subsidiary__account-alert-text"
            [innerHTML]="'SUBSIDIARY_ASSOTMENT.NOTIFICATION.MESSAGE' | translate"></span>
    </p>
  </a>
  <a class="subsidiary__account-alert-link cta__container" [href]="shoppingListLink">
    <button
      mm-button
      color="primary"
      class="subsidiary__account-alert-button"
      [fluid]="true"
      [size]="'small'"
    >
      {{ 'SUSIDIARY_ASSORTMENT.NOTIFICATION.BUTTON.LABEL' | translate }}
    </button>
  </a>
</div>
